import { computed } from 'vue';
import { brand } from 'config';
import { useAvailability } from '../../../composables/useAvailability';
import { useInitColor } from './useColor';
import ColorParser from '../parsers/ColorParser';

/**
 *
 * @param {Color} color
 * @param {Availability} availability
 * @returns {BaseColor}
 */
function toBaseColor(color, availability) {
  return {
    id: color.id,
    name: color.name,
    spriteOffset: color.swatchImage.swatchSpriteOffset,
    spriteIndex: color.swatchImage.swatchSpriteUrlIndex,
    available: availability[color.id],
    onSale: color?.pricing?.price?.priceType?.onSale || !!(color?.pricing?.price?.finalPrice),
  };
}

/**
 *
 * @param {{id: string, parsedData: ParsedColors, product: Product }} param0
 * @returns {import('vue').ComputedRef<ColorProps>}
 */
export function useInitColorPDP({ id, parsedData, product }) {
  const data = product ? ColorParser(product, { isMcom: brand === 'mcom' }) : parsedData;
  useInitColor({ id, data });

  const { color: availability } = useAvailability(id);

  return computed(() => ({
    colors: data.colorArray.map((color) => toBaseColor(color, availability.value)),
    spriteUrls: data.spriteUrls,
    priceToColors: data.priceToColors,
    priceToColorsExp: data.priceToColorsExp,
  }));
}

export default useInitColorPDP;
